<template >
  <div >
    <div v-loading="!loaded" >
      <el-card class="box-card" >
        <div
            slot="header"
            class="clearfix" >
          <el-row >
            <el-col
                :xs="2"
                :sm="2" >
              <el-link
                  type="warning"
                  xclick="goPrintThis()"
                  href="/?service=logout" >exit
              </el-link >
            </el-col >
            <el-col
                :xs="22"
                :sm="22" ></el-col >
          </el-row >
        </div >
        <div v-fill-height="10" >
          <el-row
              v-for="(section,idx) in dashBoardConfiguration"
              :key="idx" >
            <el-divider content-position="left" >{{ section.label }}</el-divider >
            <el-row v-if="section.links" >
              <el-col
                  v-for="(link,lidx) in section.links"
                  :key="lidx"
                  :md="link.size" >
                <el-link
                    type="primary"
                    :href="link.url" >{{ link.label }}
                </el-link >
              </el-col >
            </el-row >
            <el-row v-if="section.boards" >
              <el-col
                  v-for="(board,bidx) in section.boards"
                  :key="bidx"
                  :md="board.size" >
                <h5 >{{ board.label }}</h5 >
                <component
                    :is="board.componentIs"
                    v-bind="board.componentOptions" ></component >
              </el-col >
            </el-row >
          </el-row >
        </div >
      </el-card >
    </div >
  </div >
</template >

<script >
import {mapActions, mapGetters} from "vuex";
import _ from "lodash";
import * as dateHelper from "date-fns";
import * as api from "~/api/resource";

import printHtml from "~/mixins/printHtml";

export default {
  mixins: [printHtml],
  data() {
    return {
      printData: null,
      printReady: false,
      loaded: true,
      timelineView: false,
      page: 1,
      searchall: null,
      // bookingRange: [dateHelper.startOfToday(), dateHelper.endOfTomorrow()],
      bookingRangeA: "",
      bookingRangeZ: "",
      todayArrivals: [],
      todayDepartures: [],
      cols: {},
      dateFormat: "DD/MM/YY",
      // activeHotel: activeHotel,
      printoptions: {
        name: "_blank",
        specs: ["fullscreen=yes",
                "titlebar=yes",
                "scrollbars=yes"],
        styles: ["/css/app.css"]
      }
    };
  },
  async created() {
    await this.getLoggedUser();
  },
  computed: {
    ...mapGetters({
      dashBoardConfiguration: "configuration/getDashboard"
    })
  },
  methods: {
    async goPrintThis() {
      let {data} = await api.fetchProcessor("bookings/vuebookings", {
        "bookingRange[]": this.bookingRange,
        idHotel: this.activeHotel,
        searchall: this.searchall,
        limit: 0
      });
      this.printData = data.results;
      this.printReady = true;
    },
    alert(msg) {
      _log_("hell...", msg, this.bookingRangeA.getTime());
    }
  }
};
</script >

<style >
.search.x-row {
  align-items: flex-start;
}

.has-more {
  color: red;
  font-weight: 700;
}
</style >
